module.exports = __webpack_public_path__ + "static/story6-index-thumbnails-1920x1080-73b7573a23231d1206d63f909cd0b629.jpg";